import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useSelectByTheme } from "@/lib/themeAssets";
import { useAuth } from "@/lib/useAuth";

export default function GoogleSignInButton({
  onClick,
}: {
  onClick: () => void;
}) {
  const { user } = useAuth();
  const src = useSelectByTheme(
    "/signin-assets/dark/web_dark_rd_ctn.svg",
    "/signin-assets/light/web_light_rd_ctn.svg",
    "/signin-assets/neutral/web_neutral_rd_ctn.svg"
  );
  if (user) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      sx={{
        p: 0,
        minWidth: 0,
        minHeight: 0,
        background: "transparent",
        border: "none",
        boxShadow: "none",
        "&:hover": {
          background: "transparent",
        },
      }}
    >
      <Box
        component="img"
        src={src}
        alt="Sign in with Google"
        sx={{
          width: "auto",
          height: 40,
          display: "block",
        }}
      />
    </Button>
  );
}
